export enum ERevenueAgencyFakeType {
	None = 'None',
	AccountFB = 'AccountFB', // Accounts FB
	Creo = 'Creo', // Крео
	Installs = 'Installs', // Инсталлы
	// AgencyPercent = 'AgencyPercent', // % Агентских
	Slices = 'Slices', // Срезы
}

export const REVENUE_AGENCY_FAKE_TYPE_LABEL_MAP: Record<ERevenueAgencyFakeType, string> = {
	[ERevenueAgencyFakeType.None]: `revenue_agency_fake_type.${ERevenueAgencyFakeType.None}`,
	[ERevenueAgencyFakeType.AccountFB]: `revenue_agency_fake_type.${ERevenueAgencyFakeType.AccountFB}`,
	[ERevenueAgencyFakeType.Creo]: `revenue_agency_fake_type.${ERevenueAgencyFakeType.Creo}`,
	[ERevenueAgencyFakeType.Installs]: `revenue_agency_fake_type.${ERevenueAgencyFakeType.Installs}`,
	[ERevenueAgencyFakeType.Slices]: `revenue_agency_fake_type.${ERevenueAgencyFakeType.Slices}`
}